import { render, staticRenderFns } from "./upData.vue?vue&type=template&id=d68bf72a&scoped=true&"
import script from "./upData.vue?vue&type=script&lang=js&"
export * from "./upData.vue?vue&type=script&lang=js&"
import style0 from "./upData.vue?vue&type=style&index=0&id=d68bf72a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d68bf72a",
  null
  
)

export default component.exports